import React, { useState } from "react";
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';
import { Select, MenuItem, InputLabel, FormControl, FormHelperText } from '@mui/material';
import Button from '@mui/material/Button';
import LogTable from "./logtable";
import axios from "../../../axios-order";
import { toast } from "react-toastify";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DatePicker from "../../../components/ui/DatePicker";
import { ValidatorForm } from "react-material-ui-form-validator";
import moment from "moment";

const Form16 = ({ refresh, onFormSubmit }) => {
  const currentYear = new Date().getFullYear();
  const [businessEntityId, setBusinessEntityId] = useState(localStorage.getItem("business_entity_id"));
  const [loading, setLoading] = useState(false);
  const [isCardVisible, setIsCardVisible] = useState(true);
  const [isDataLoadingEnabled, setIsDataLoadingEnabled] = useState(false);
  const [showLogTable, setShowLogTable] = useState(false);
  const [fromDateMonthYearDisplay, setFromDateMonthYearDisplay] = useState(null);

  const [formData, setFormData] = useState({
    form: '',
    financial_year: '',
    quarter: '',
    provisional_receipt_number: '',
    bsr_code: '',
    challan_date: '',
    challan_serial_no: '',
    challan_amount: '',
    unique_pan_amount_combination_for_challan: [
      { pan: '', total_amount_deposited_against_pan: '' },
      { pan: '', total_amount_deposited_against_pan: '' },
      { pan: '', total_amount_deposited_against_pan: '' }
    ],
    business_entity_id: businessEntityId || "",
    remember_me: false
  });

  const [errors, setErrors] = useState({
    challan_date: '',
    form: '',
    quarter: '',
    financial_year: '',
    bsr_code: '',
    challan_serial_no: '',
    provisional_receipt_number: '',
    challan_amount: '',
    unique_pan_amount_combination_for_challan: '',
  });

  const [challanDate, setDisplayChallanDate] = useState('')

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    let newErrors = { ...errors };

    if (name === "pan") {
      const updatedData = [...formData.unique_pan_amount_combination_for_challan];
      updatedData[index].pan = value;
      setFormData({
        ...formData,
        unique_pan_amount_combination_for_challan: updatedData,
      });
    }
    else if (name === "total_amount_deposited_against_pan") {
      const updatedData = [...formData.unique_pan_amount_combination_for_challan];
      updatedData[index].total_amount_deposited_against_pan = value;
      setFormData({
        ...formData,
        unique_pan_amount_combination_for_challan: updatedData,
      });
    }
    else if (name === "challan_date") {
      if (value) {
        const dateParts = value.split('-');
        if (dateParts.length === 3) {
          const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
          setFormData({
            ...formData,
            [name]: formattedDate,
          });
        } else {
          setFormData({
            ...formData,
            [name]: value,
          });
        }
      } else {
        setFormData({
          ...formData,
          [name]: '',
        });
      }
    }
    else {
      if (name === "form") {
        console.log("Resetting quarter because form changed");
        // Always reset quarter when form type changes
        setFormData({
          ...formData,
          [name]: value,
          quarter: "",
        });
      } else {
        console.log("Updating field:", name, "with value:", value);
      setFormData({
        ...formData,
        [name]: value,
      });
      }
      if (name === "bsr_code") {
        newErrors[name] = validateBSRCode(value);
      }
      else if (name === "challan_serial_no") {
        newErrors[name] = validateChallanSerialNumber(value);
      }
      else if (name === "challan_amount") {
        newErrors[name] = validateChallanAmount(value);
      }
    }

    setErrors(newErrors);
  };

  const inputHandlerFromDatePicker = (v) => {
    setFromDateMonthYearDisplay(v);
  };

  const handleProceedClick = () => {
    let newErrors = {};

    if (!formData.form) {
      newErrors.form = "Please select a form type.";
    }

    if (!formData.quarter) {
      newErrors.quarter = "Please select a quarter.";
    }

    if (!formData.financial_year) {
      newErrors.financial_year = "Please select a financial year.";
    }

    if (!formData.bsr_code) {
      newErrors.bsr_code = "BSR Code is required.";
    }

    if (!formData.challan_serial_no) {
      newErrors.challan_serial_no = "Challan Serial Number is required.";
    }

    const provisionalReceiptRegex = /^[A-Za-z0-9]{6,}$/;
    if (!formData.provisional_receipt_number) {
      newErrors.provisional_receipt_number = "Provisional Receipt Number is required.";
    }
    else {
      if (!provisionalReceiptRegex.test(formData.provisional_receipt_number)) {
        newErrors.provisional_receipt_number = "Provisional Receipt Number must be alphanumeric and at least 6 characters long.";
      }
    }

    if (!formData.challan_amount || isNaN(formData.challan_amount)) {
      newErrors.challan_amount = "Challan Amount must be a valid number.";
    }

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    // Only validate PAN 1
    if (!formData.unique_pan_amount_combination_for_challan[0].pan || !panRegex.test(formData.unique_pan_amount_combination_for_challan[0].pan)) {
      newErrors.pan_error_0 = "Invalid PAN format for PAN 1. PAN should be in the format AAAAA1234A.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const structuredData = {
      business_entity_id: businessEntityId,
      quarter: formData.quarter,
      financial_year: formData.financial_year,
      form: formData.form,
      bsr_code: formData.bsr_code,
      challan_date: formData.challan_date,
      challan_serial_no: formData.challan_serial_no,
      provisional_receipt_number: formData.provisional_receipt_number,
      challan_amount: parseFloat(formData.challan_amount),
      unique_pan_amount_combination_for_challan: [
        ["sr_no", "pan", "total_amount_deposited_against_pan"],
        ...formData.unique_pan_amount_combination_for_challan
          .filter(item => item.pan || item.total_amount_deposited_against_pan)
          .map((item, index) => [
            index + 1,
            item.pan,
            parseFloat(item.total_amount_deposited_against_pan) || 0,
          ])
      ],
      remember_me: formData.remember_me,
    };

    console.log(structuredData);

    setIsDataLoadingEnabled(true);
    axios.post('/form_16_report', structuredData)
      .then((res) => {
        console.log('API Response:', res?.data);
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        let errorMessage = "An error occurred while fetching data.";
        if (err.response) {
          if (err.response.status === 404) {
            errorMessage = err.response?.data?.message || "Requested resource not found (404).";
          } else if (err.response.data?.message) {
            errorMessage = err.response.data.message;
          }
        } else if (err.request) {
          errorMessage = "No response received from the server.";
        }

        toast.error(errorMessage, {
          autoClose: 3000,
          progress: 0,
        });
      })
      .finally(() => {
        setIsCardVisible(false); // Moved to finally block
        refresh();
        onFormSubmit();
        setLoading(false);
      });
  };

    const handleCancelClick = () => {
    setFormData({
      form: '',
      financial_year: '',
      quarter: '',
      provisional_receipt_number: '',
      bsr_code: '',
      challan_date: '',
      challan_serial_no: '',
      challan_amount: '',
      unique_pan_amount_combination_for_challan: [
        { pan: '', total_amount_deposited_against_pan: '' },
        { pan: '', total_amount_deposited_against_pan: '' },
        { pan: '', total_amount_deposited_against_pan: '' }
      ],
      business_entity_id: businessEntityId || "",
      remember_me: false
    });
    setErrors({
      challan_date: '',
      form: '',
      quarter: '',
      financial_year: '',
      bsr_code: '',
      challan_serial_no: '',
      provisional_receipt_number: '',
      challan_amount: '',
      unique_pan_amount_combination_for_challan: '',
    });
    setDisplayChallanDate('');
  };

  const validateBSRCode = (value) => {
    if (!value || value.trim() === '') {
      return 'BSR code is required';
    }
    else if (!/^\d{7}$/.test(value)) {
      return 'Please enter a valid 7-digit BSR code';
    }
    return '';
  };

  const validateChallanSerialNumber = (value) => {
    if (!value || value.trim() === '') {
      return 'Challan serial number is required';
    }
    else if (!/^\d{5}$/.test(value)) {
      return 'Please enter a valid 5-digit challan serial number';
    }
    return '';
  };

  const validateChallanAmount = (value) => {
    if (!value || value.trim() === '') {
      return 'Challan amount is required';
    }
    else if (isNaN(value) || parseFloat(value) <= 0) {
      return 'Please enter a valid positive amount';
    }
    else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
      return 'Please enter a valid amount with up to 2 decimal places';
    }
    return '';
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) return dateString;
    const dateParts = dateString.split('-');
    if (dateParts.length === 3) {
      return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    }
    return dateString;
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const dateParts = dateString.split('-');
    if (dateParts.length === 3) {
      return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    }
    return dateString;
  };

  const years = Array.from({ length: 18 }, (_, index) => {
    const startYear = currentYear - 5 + index;
    const endYear = startYear + 1;
    return `${startYear}-${endYear.toString().slice(-2)}`;
  });

  const onDateChnageHandler = (v) => {
    setDisplayChallanDate(v);
    const date = moment(v).format("DD-MM-YYYY");
    setFormData({
      ...formData,
      challan_date: date,
    });
  };

  const sectionStyle = {
    marginBottom: '24px',
    padding: '16px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  };

  const sectionTitleStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '16px',
    borderBottom: '1px solid #eaeaea',
    paddingBottom: '8px'
  };

  const inputLabelStyle = {
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '5px',
    display: 'block',
    color: '#555'
  };

  const requiredMark = {
    color: 'red',
    marginLeft: '2px'
  };

  return (
    <div>
      {isCardVisible && (
        <Box sx={{ width: '100%' }}>
          <Paper
            elevation={2}
            sx={{
              p: { xs: 2, sm: 3 },
              mt: 2,
              mb: 2,
              width: '100%',
              backgroundColor: '#f9f9f9'
            }}
          >
            <Box>
              <Typography variant="h6" component="div" sx={{ mb: 3, fontWeight: 'bold', color: '#333' }}>
                Create Form 16/16A
              </Typography>

              <Box sx={sectionStyle}>
                <Typography sx={sectionTitleStyle}>Basic Information</Typography>
                <Grid container spacing={3} sx={{ maxWidth: '100%' }}>
                  <Grid item xs={12} sm={4} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="form-type">
                      Form Type<span style={requiredMark}>*</span>
                    </InputLabel>
                    <FormControl fullWidth size="small" sx={{ maxWidth: '250px' }}>
                      <Select
                        value={formData.form || ''}
                        name="form"
                        onChange={handleInputChange}
                        error={!!errors.form}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>Select Form Type</MenuItem>
                        <MenuItem value="26Q">26Q</MenuItem>
                        <MenuItem value="24Q">24Q</MenuItem>
                        <MenuItem value="27Q">27Q</MenuItem>
                      </Select>
                      {errors.form && <FormHelperText error>{errors.form}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="financial-year">
                      Financial Year<span style={requiredMark}>*</span>
                    </InputLabel>
                    <FormControl fullWidth size="small" sx={{ maxWidth: '250px' }}>
                      <Select
                        value={formData.financial_year || ''}
                        name="financial_year"
                        onChange={handleInputChange}
                        error={!!errors.financial_year}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>Select Financial Year</MenuItem>
                        {years.map((year, index) => (
                          <MenuItem key={index} value={year}>{year}</MenuItem>
                        ))}
                      </Select>
                      {errors.financial_year && <FormHelperText error>{errors.financial_year}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="quarter">
                      Quarter<span style={requiredMark}>*</span>
                    </InputLabel>
                    <FormControl fullWidth size="small" sx={{ maxWidth: '250px' }}>
                      <Select
                        value={formData.quarter || ''}
                        name="quarter"
                        onChange={handleInputChange}
                        error={!!errors.quarter}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>Select Quarter</MenuItem>
                        {formData.form !== "24Q" && <MenuItem value="Q1">Q1</MenuItem>}
                        {formData.form !== "24Q" && <MenuItem value="Q2">Q2</MenuItem>}
                        {formData.form !== "24Q" && <MenuItem value="Q3">Q3</MenuItem>}
                        <MenuItem value="Q4">Q4</MenuItem>
                      </Select>
                      {errors.quarter && <FormHelperText error>{errors.quarter}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={sectionStyle}>
                <Typography sx={sectionTitleStyle}>Company Information</Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="bsr_code">
                      BSR Code<span style={requiredMark}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="bsr_code"
                      name="bsr_code"
                      value={formData.bsr_code || ''}
                      onChange={handleInputChange}
                      error={!!errors.bsr_code}
                      helperText={errors.bsr_code}
                      placeholder="Enter BSR Code"
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="challan_serial_no">
                      Challan Serial Number<span style={requiredMark}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="challan_serial_no"
                      name="challan_serial_no"
                      value={formData.challan_serial_no || ''}
                      onChange={handleInputChange}
                      error={!!errors.challan_serial_no}
                      helperText={errors.challan_serial_no}
                      placeholder="Enter Challan Serial No"
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="provisional_receipt_number">
                      Token Number<span style={requiredMark}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="provisional_receipt_number"
                      name="provisional_receipt_number"
                      value={formData.provisional_receipt_number || ''}
                      onChange={handleInputChange}
                      error={!!errors.provisional_receipt_number}
                      helperText={errors.provisional_receipt_number}
                      placeholder="Enter Token Number"
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="challan_amount">
                      Total Challan Amount<span style={requiredMark}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="challan_amount"
                      name="challan_amount"
                      value={formData.challan_amount || ''}
                      onChange={handleInputChange}
                      error={!!errors.challan_amount}
                      helperText={errors.challan_amount}
                      placeholder="Enter Challan Amount"
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <ValidatorForm>
                      <InputLabel sx={inputLabelStyle} htmlFor="challan_date">
                        Challan Date<span style={requiredMark}>*</span>
                      </InputLabel>
                      <FormControl fullWidth size="small" sx={{ maxWidth: '250px' }}>
                        <DatePicker
                          value={challanDate ?? ""}
                          placeholder="Challan Date"
                          errorMessages={["This field is required"]}
                          validators={["required"]}
                          onChange={(v) => onDateChnageHandler(v)}
                          error={!!errors.challan_date}
                          helperText={errors.challan_date}
                        />
                      </FormControl>
                    </ValidatorForm>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={sectionStyle}>
                <Box sx={{ justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography sx={sectionTitleStyle}>PAN Details</Typography>
                  <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', }}>
                    Enter up to 3 unique PAN-Amount pairs linked to the challan. If fewer, include all available
                  </Typography>
                </Box>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="pan-0">
                      PAN 1<span style={requiredMark}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="pan-0"
                      name="pan"
                      value={formData.unique_pan_amount_combination_for_challan[0].pan}
                      onChange={(e) => handleInputChange(e, 0)}
                      error={!!errors.pan_error_0}
                      helperText={errors.pan_error_0}
                      InputLabelProps={{ shrink: true }}
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="pan-1">
                      PAN 2
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="pan-1"
                      name="pan"
                      value={formData.unique_pan_amount_combination_for_challan[1].pan}
                      onChange={(e) => handleInputChange(e, 1)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="pan-2">
                      PAN 3
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="pan-2"
                      name="pan"
                      value={formData.unique_pan_amount_combination_for_challan[2].pan}
                      onChange={(e) => handleInputChange(e, 2)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Box sx={sectionStyle}>
                <Typography sx={sectionTitleStyle}>Total Amount Deduction</Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="total_amount_deposited_against_pan-0">
                      Total Amount Deduction<span style={requiredMark}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="total_amount_deposited_against_pan-0"
                      name="total_amount_deposited_against_pan"
                      value={formData.unique_pan_amount_combination_for_challan[0].total_amount_deposited_against_pan}
                      onChange={(e) => handleInputChange(e, 0)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="total_amount_deposited_against_pan-1">
                      Total Amount Deduction
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      name="total_amount_deposited_against_pan"
                      id="total_amount_deposited_against_pan-1"
                      value={formData.unique_pan_amount_combination_for_challan[1].total_amount_deposited_against_pan}
                      onChange={(e) => handleInputChange(e, 1)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputLabel sx={inputLabelStyle} htmlFor="total_amount_deposited_against_pan-2">
                      Total Amount Deduction
                    </InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      id="total_amount_deposited_against_pan-2"
                      name="total_amount_deposited_against_pan"
                      value={formData.unique_pan_amount_combination_for_challan[2].total_amount_deposited_against_pan}
                      onChange={(e) => handleInputChange(e, 2)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ maxWidth: '250px' }}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                mt: 3,
                gap: 2
              }}>
                {isDataLoadingEnabled && (
                  <Button
                    variant="outlined"
                    color="info"
                    startIcon={
                      <HourglassBottomIcon
                        sx={{
                          animation: 'spin 2s linear infinite',
                          '@keyframes spin': {
                            '0%': { transform: 'rotate(0deg)' },
                            '100%': { transform: 'rotate(360deg)' },
                          },
                        }}
                      />
                    }
                  >
                    Data Loading
                  </Button>
                )}
                <Button variant="outlined" color="error"
                 onClick={handleCancelClick}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleProceedClick}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Paper>
        </Box>
      )}

      {showLogTable && (
        <Box sx={{ width: '100%' }}>
          <Paper
            elevation={2}
            sx={{
              p: { xs: 2, sm: 3 },
              mt: 2,
              mb: 2,
              width: '100%',
              backgroundColor: '#f9f9f9'
            }}
          >
            <Box sx={{ mt: 2 }}>
              <LogTable />
            </Box>
          </Paper>
        </Box>
      )}
    </div>
  );
};

export default Form16;